// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3xCqL","icon":"SortAdornment_icon__ufHNS","up":"SortAdornment_up__3P49B","down":"SortAdornment_down__1EJOO","active":"SortAdornment_active__1n8MU"};